/*
 * 配置编译环境和线上环境之间的切换
 * baseUrl: 域名地址
 */

//页面调用后端api所使用的地址
let baseUrl = ''
let baseUrl2 = ''
let DEBUG = false
if (process.env.NODE_ENV === 'development') {
  baseUrl = 'https://cloudmalltest.counton.com.cn/bshop-srv/'
  baseUrl2 = 'https://cloudmalltest.counton.com.cn/commbank-ip/#'
  DEBUG = false
} else if (process.env.NODE_ENV === 'test') {
  baseUrl = 'https://cloudmalltest.counton.com.cn/bshop-srv/'
  baseUrl2 = 'https://cloudmalltest.counton.com.cn/commbank-ip/#'
  DEBUG = false
} else if (process.env.NODE_ENV === 'sit') {
  baseUrl = 'https://cloudmalltest.counton.com.cn/bshop-srv/'
  baseUrl2 = 'https://cloudmalltest.counton.com.cn/commbank-ip/#'
  DEBUG = false
} else if (process.env.NODE_ENV === 'production') {
  baseUrl = 'https://cloudmall.counton.com.cn/bshop-srv/'
  baseUrl2 = 'https://cloudmall.counton.com.cn/commbank-ip/#'
  DEBUG = false
}

export { baseUrl, baseUrl2, DEBUG }



// WEBPACK FOOTER //
// ./src/common/env.js